import React from "react";

import moment from "moment";

import * as S from "./ComparisonTimeFrameIndicator.style";
import {
  ComparisonTimeFrame,
  ComparisonSide,
  ComparisonSideTimeFrame
} from "./types";

type ComparisonSideTimeFrameIndicatorProps = {
  side: ComparisonSide;
  comparisonSideTimeframe: ComparisonSideTimeFrame;
};

type ComparisonTimeFrameIndicatorProps = {
  comparisonTimeframe: ComparisonTimeFrame;
};

const ComparisonSideTimeFrameIndicator = ({
  side,
  comparisonSideTimeframe
}: ComparisonSideTimeFrameIndicatorProps) => {
  return (
    <S.Box className={`side${side}`}>
      <S.Label>{side}</S.Label>
      <S.Label>
        {comparisonSideTimeframe.from.toDateString() ===
        comparisonSideTimeframe.to.toDateString()
          ? `${moment(comparisonSideTimeframe.from).format("MMM D, YYYY \\f\\r\\o\\m HH:mm")} to ${moment(comparisonSideTimeframe.to).format("HH:mm (\\U\\T\\CZ)")}`
          : `from ${moment(comparisonSideTimeframe.from).format("MMM D, YYYY \\a\\t HH:mm")} to ${moment(comparisonSideTimeframe.to).format("MMM D, YYYY \\a\\t HH:mm (\\U\\T\\CZ)")}`}
      </S.Label>
    </S.Box>
  );
};

const ComparisonTimeFrameIndicator = ({
  comparisonTimeframe
}: ComparisonTimeFrameIndicatorProps) => {
  return (
    <S.Layout>
      <ComparisonSideTimeFrameIndicator
        side="A"
        comparisonSideTimeframe={comparisonTimeframe.sideA}
      />
      <ComparisonSideTimeFrameIndicator
        side="B"
        comparisonSideTimeframe={comparisonTimeframe.sideB}
      />
    </S.Layout>
  );
};

export default ComparisonTimeFrameIndicator;
